const initialState = {
    currentLang: { lang: 'en', id: 2 },
};

export default initialState;
